import { createApp } from 'vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';
import Site from './Site.vue';
import store from './store';
import { apolloProvider } from './apollo';

import router from './router';

library.add(fas, far, fab);

createApp(Site)
  .use(store)
  .use(apolloProvider)
  .use(router)
  .component('font-awesome-icon', FontAwesomeIcon)
  .mount('#app');
